class Door {
  stateClasses = {
    prices: 'show-prices',
  };

  constructor($el) {
    this.$el = $el;
    this.$price = this.$el.find('[data-door="price"]');
    this.$quantity = this.$el.find('[data-door="quantity"]');
    this.$discount = this.$el.find('[data-door="discount"]');
    this.prices = this.$el.data('prices');
    this.quantity = Number(this.$quantity.val());
    this.init();
  }

  init = () => {
    console.log('door', this);
    this.$quantity.on('change', this.updatePrice);
    this.$discount.on('click', this.togglePricelist);
    this.updatePrice();
  };

  updatePrice = () => {
    const quantity = Number(this.$quantity.val());
    console.log('quantity', quantity);

    const priceCategory = this.prices.find((price) => {
      return quantity >= price.quantityMin && (price.quantityMax == null || quantity <= price.quantityMax);
    });

    let price = quantity * priceCategory.price;

    // format price like this 1'000
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’");

    this.$price.text(price);
  };

  togglePricelist = () => {
    this.$el.toggleClass(this.stateClasses.prices);
  }; 
}

export default Door;